import { throttle } from 'lodash';
import React from 'react';
import { useMutationObserver } from './useMutationObserver';

export function useElementHeight(ref: React.RefObject<any>) {
  const [height, setHeight] = React.useState(0);
  const updateHeight = React.useCallback(
    throttle(() => setHeight(ref.current.clientHeight), 200),
    []
  );
  useMutationObserver(ref, updateHeight);
  React.useEffect(() => {
    updateHeight();
    window.addEventListener('resize', updateHeight);
    return () => {
      window.removeEventListener('resize', updateHeight);
    };
  }, [updateHeight, ref]);

  return height;
}
